import { render, staticRenderFns } from "./v-date-field.vue?vue&type=template&id=45ba022f"
import script from "./v-date-field.vue?vue&type=script&lang=js"
export * from "./v-date-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports